import React from "react";



const Contacts = () => {
    return (
        <main className="section">
                <div className="container">
                        <h1 className="title-1">Contacts</h1>
                        <ul className="content-list">
                            <li className="content-list__item">
                                <h2 className="title-2">Location</h2>
                                <p>Minsk, Belarus</p>
                            </li>
                            <li className="content-list__item">
                                <h2 className="title-2">Telegram / WhatsApp</h2>
                                <p><a href="tel:80336799627">80 (33) 679-96-27</a></p>
                            </li>
                            <li className="content-list__item">
                                <h2 className="title-2">Email</h2>
                                <p><a href="mailto:krivelo2017@mail.ru">krivelo2017@mail.ru</a></p>
                            </li>
                        </ul>
                </div>
            </main>
    )
}



export default Contacts;